"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafetyMeasuresDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.SafetyMeasuresDescription = {
    priority: 3,
    label: 'fields.payload.mor_group_answers.safety_measures_description.label',
    fallbackLabel: 'If no Enhanced Due Diligence process is in place, what safeguards do you implement when dealing with customers or merchants that carry increased risk and typically would be subject to additional checks or other safety measures?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_process_for_enhanced_due_diligence', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_process_for_enhanced_due_diligence === false
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_process_for_enhanced_due_diligence === false
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
